module.exports = __webpack_public_path__ + "img/E2 DP1.6413e984.png";